import {
  formatSendMoney,
  formatSendMoneyWithCode,
} from "@/modules/dashboard/dispersions/components/WalletSend/formatSendMoney";
import { CurrencyFlag } from "@/modules/dashboard/wallets/components/CurrencyFlag";
import { ColocaMoneyTransit } from "@/shared/components/motion/ColocaMoneyTransit";
import useTranslations from "@/shared/lang/useTranslations";

export interface SwapTransitProps {
  from: string;
  to: string;
  debit: string;
  credit: string;
  className?: string;
}

/** The conversion as it happens: pesos leave one wallet, change face at Coloca and land in the other. */
export function SwapTransit({ from, to, debit, credit, className }: SwapTransitProps) {
  const { t, activeLanguage } = useTranslations("swaps");
  return (
    <ColocaMoneyTransit
      className={className}
      label={t("convert_transit_aria", {
        debit: formatSendMoneyWithCode(debit, from, activeLanguage),
        credit: formatSendMoneyWithCode(credit, to, activeLanguage),
        from,
        to,
      })}
      from={{
        icon: <CurrencyFlag currency={from} size="md" />,
        label: t("convert_wallet", { currency: from }),
        caption: formatSendMoney(debit, from, activeLanguage),
      }}
      to={{
        icon: <CurrencyFlag currency={to} size="md" />,
        label: t("convert_wallet", { currency: to }),
        caption: formatSendMoney(credit, to, activeLanguage),
      }}
      legs={[
        { rail: { kind: "fiat" }, asset: { kind: "fiat", currency: from } },
        { rail: { kind: "fiat" }, asset: { kind: "fiat", currency: to } },
      ]}
    />
  );
}
